// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyDv5dHMjgq_6GWD35Of-cTXskRk1rXncws',
  authDomain: 'filmoteka-command-project-js.firebaseapp.com',
  projectId: 'filmoteka-command-project-js',
  storageBucket: 'filmoteka-command-project-js.appspot.com',
  messagingSenderId: '1084933608284',
  appId: '1:1084933608284:web:16097211c819e6fa8d6799',
  measurementId: 'G-BHYJP9WVT4',
};

// Initialize Firebase
